<template>
    <div>
        <div v-if="is_can_update_field">
            <span style="vertical-align: middle;">
                <span v-if="core_waybill.receipt_file_url">
                    <!-- 重新 -->
                    {{ $t('ui.pages.core_waybills.again') }}
                </span>
                <!-- 上傳圖片： -->
                {{ $t('ui.pages.core_waybills.upload_picture') }}：
            </span>
            <FileUploader
                style="display: inline-block; vertical-align: middle;"
                :channel="eventbus.file_uploader.name"
            ></FileUploader>
            <span style="vertical-align: middle;"
                :style="{
                    color : eventbus.file_uploader.status == 'failure' ? 'red' : ''}"
                >
                {{ eventbus.file_uploader.message }}
            </span>
        </div>
        <div class="receipt_file"
            v-if="core_waybill.receipt_file_url">
            <a
                :href="core_waybill.receipt_file_url"
                target="_blank">
                <img
                    :src="core_waybill.receipt_file_url"
                    style="max-width:100%;"
                />
            </a>
            <div class="copy_div">
                <div class="pointer" @click="$bus.$emit(eventbus.copy_field.name, 'receipt_file_url')">
                    <i class="large circular inverted copy icon z-depth-2">
                    </i>
                </div>
            </div>
        </div>

        <div
            v-else
            class="ui message" style="margin: 0; padding: 10px 12px;">
            <!-- 無上傳圖片 -->
            {{ $t('ui.pages.core_waybills.no_upload_any_picture') }}
        </div>

    </div>
</template>

<script>
import FileUploader from "@toolbox/file_uploader/main.vue"

export default {
    props: {
        core_waybill: {
            default: {},
            type: Object
        },
        is_can_update_field: {
            default: false,
            type: Boolean,
        },
        eventbus: {
            default: {
                change_current_template: {
                    name: "",
                },
                file_uploader: {
                    name: "",
                },
                update_core_waybill: {
                    name: "",
                },
                print_label: {
                    name: "",
                },
            },
            type: Object,
        },
    },
    data() {
        return {
        }
    },
    created() {
    },
    mounted() {
    },
    computed: {
    },
    methods: {
    },
    components: {
        FileUploader
    },
}
</script>

<style lang="scss" scoped>
    .segment.core_waybill_partition {
        margin-top: 0;
    }

    .receipt_file {
        & {
            display: inline-block;
            position: relative;
        }
        .copy_div {
            position: absolute;
            right: 0;
            bottom: 0;
        }
    }

</style>
